import { Component, Input } from '@angular/core'
import { SearchModule } from '@usitsdasdesign/dds-ng/search'
import { ICategory } from '../categories/typings';
import { HighlightModule } from '@usitsdasdesign/dds-ng/shared/highlight';
import { RouterModule } from '@angular/router';
import { SearchService } from '../services/search.service';
import { EnableSpellcheckDirective } from '../directives/enable-spellcheck.directive';
import { debounceTime, distinctUntilChanged, filter, Subject, switchMap, tap } from 'rxjs';
import { ICategorySearch, ISearchResult } from './typings';

const DEBOUNCE_TIME = 300;
const MIN_CHARACTERS_TO_SEARCH = 3;

@Component({
  selector: 'app-search',
  standalone: true,
  imports: [
    SearchModule,
    HighlightModule,
    RouterModule,
    EnableSpellcheckDirective,
  ],
  templateUrl: './search.component.html',
  styleUrl: './search.component.scss',
})
export class SearchComponent {
  @Input() placeholder = 'Search';

  resultsList: ICategory[];
  searchValue: string;
  searchResultsList: ICategorySearch[];
  isLoading: boolean = false;
  noResultsFound: boolean = false;
  private searchTerms = new Subject<string>();
  constructor(private searchService: SearchService) {
    this.searchTerms
      .pipe(
        debounceTime(DEBOUNCE_TIME),
        distinctUntilChanged(),
        filter(term => term.length >= MIN_CHARACTERS_TO_SEARCH),
        tap(() => this.isLoading = true),
        switchMap((term: string) => this.searchService.getSearchResults(term))
      ).subscribe({
        next: (response: ISearchResult) => {
          this.searchResultsList = response?.searchResult;
          this.isLoading = false;
          if (response?.searchResult.length == 0) {
            this.noResultsFound = true;
          }
        },
        error: (error) => {
          console.error(error);
          this.isLoading = false;
        }
      }
      );
  }

  generatePath(title: string): string {
    return title.toLowerCase()
      .trim()
      .replace(/[\s]+/g, '-')
      .replace(/[^\w\-]+/g, '');
  }

  search(value: string): void {
    this.searchResultsList = [];
    this.searchValue = value;
    this.isLoading = false;
    this.noResultsFound = false;
    this.searchTerms.next(value);
  }
}
